import { render, staticRenderFns } from "./BackCoverUAPromoArea.vue?vue&type=template&id=5870c872&"
import script from "./BackCoverUAPromoArea.vue?vue&type=script&lang=js&"
export * from "./BackCoverUAPromoArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports